import React from "react";

class Option extends React.Component {
    constructor(props) {
        super(props);
    }

    handleSelect = async (event) => {
        const { props } = this;
        const { option } = props;
        
        event.stopPropagation();
        if (props.onSelectOption) {
            const valid = await props.onSelectOption(option);

            if (!valid) {
                return;
            }
        }

        props.onUpdateState({selected: option, inputValue: "", showSelected: true}, async () => {
            if(props.onChange) {
                await props.onChange(option);
            }
            
            if(props.closeOnChange) {
                props.onClose();
            }
        });
    }

    render() {
        const { props } = this;
        const { option } = props;
   
         return (
            <div key={`selectOptionKey_${option.label}`} class="selectOption">
                {props.link? <a href={option.link} onClick={this.handleSelect} class={`optionTrigger ${props.selected.value === option.value ? "active" : ""}`}>
                    {props.renderOption ? props.renderOption(option) : <span>{option.label}</span>}
                    {props.selected.value === option.value && props.showActiveIcon && <i class="material-icons">done</i>}
                </a>
                : <a onClick={this.handleSelect} class={`optionTrigger ${props.selected.value === option.value ? "active" : ""}`}>
                {props.renderOption ? props.renderOption(option) : <span>{option.label}</span>}
                {props.selected.value === option.value && props.showActiveIcon && <i class="material-icons">done</i>}
            </a>}
                
            </div>
        )
    }
}

export default Option;